import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { fetchSyncStatus } from "../api/fetchSyncStatus";

export const useSyncStatus = ({ page = 1, limit = 10, filter = "all", search = "" } = {}) => {
  return useQuery({
    queryKey: ["syncStatus", page, limit, filter, search],
    queryFn: () => fetchSyncStatus({ page, limit, filter, search }),
    staleTime: 30000,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
};
